import React, { useState } from "react";
import dynamic from "next/dynamic";
import Head from "next/head";
import NotFoundPage from "../../404";
import { useRouter } from "next/router";

const DetailView = dynamic(() =>
  import("../../../components/UI/Gallery/DetailView")
);
const FullImg = dynamic(() =>
  import("components/UI/Gallery/DetailView/Blocks/FullImg")
);

export default function GalleryDetail(props) {
  const router = useRouter();

  if (!router.isFallback && !props.data?.results.name) {
    return <NotFoundPage />;
  }

  if (router.isFallback) {
    return <div>Loading...</div>;
  }

  const { results: item } = props.data;
  const [fullImg, setFullImg] = useState();
  const FullImgFunk = (item) => setFullImg(item);

  const meta = {
    title: "",
    description: "",
  };

  try {
    meta.title = `Paywall ${item.name}`;
    meta.description = [
      `Category: ${item.categories.map((c) => c.name)[0]}`,
      `Platform: ${item.platform}`,
      `Call to action: ${item.call_to_actions.map((a) => a.name)[0]}`,
      `Version: ${item.versions.map((v) => v.name)[0]}`,
    ].join(", ");
  } catch (e) {
    // console.log(e);
  }

  return (
    <div className="wrapper no-overflow-hidden">
      {fullImg && (
        <FullImg
          data={fullImg?.data}
          fullImgState={fullImg?.key}
          fullImg={FullImgFunk}
        />
      )}
      <Head>
        <title>{props.data?.results.name}</title>
        <link
          rel="canonical"
          href={`https://apphud.com/gallery/${props.data?.results.id}`}
        />
        <meta name="title" content={meta.title} />
        <meta name="description" content={meta.description} />
        <meta property="og:title" content={meta.title} />
        <meta property="og:type" content="website" />
        <meta property="og:image" content={props.data?.results.og_cover_url} />
      </Head>
      <DetailView data={item} fullImg={FullImgFunk} fullImgState={fullImg} />
    </div>
  );
}

export async function getServerSideProps(context) {
  const { params } = context;
  const item = await fetch(
    `https://api.apphud.com/gallery/apps/${params.slug}`
  );
  return {
    props: {
      data: await item.json(),
    },
  };
}
